import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "../../assets/Styles/Slider.css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { useSelector } from "react-redux";

const HeaderSlider = () => {
  const [slides, setSlides] = useState([]);
  const userData = useSelector(
    (state) => state.fetchUser?.user?.customRibbonInfo
  );

  useEffect(() => {
    // Extract customRibbonInfo once userData is available
    if (userData) {
      const customRibbonInfo = userData.map((info) => info.title);
      setSlides(customRibbonInfo);
    } else {
      setSlides([]); // Clear slides if no customRibbonInfo is present
    }
  }, [userData]);

  return (
    <React.Fragment>
      {slides.length > 0 ?
      
      
      
      
      ( 
        <div className="slider-container header-slider">
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation
            loop={true} 
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            className="custom-swiper"
          >
            {slides.map((text, index) => (
              <SwiperSlide key={index} className="slide">
                {text}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        // Empty div to ensure no visual elements, including background
        <div className="no-slider"></div>
      )}
    </React.Fragment>
  );
};

export default HeaderSlider;
